import { Vue, Component, Prop } from 'vue-property-decorator';

import SubjectResponse from '../../models/responses/SubjectResponse';

/**
 * Subject card to display an subjects with name and average grade.
 *
 * @param subject - a single subject
 */
@Component({
  name: 'SubjectCard',
  template: '#subject-card',
})
export default class SubjectCard extends Vue {
  @Prop(Object) private subject: SubjectResponse | undefined;

  /**
   * routes to detail page
   */
  public goToSubjectDetail() {
    if (!this.subject) return;
    this.$router.push('/subject-detail/' + this.subject.id);
  }
}
